import { type ReactNode } from 'react';

import { cn } from '@/utils/cn';

import { IconWell, type IconWellTone } from '../ui/IconWell';

export interface EmptyStateProps {
  icon?: ReactNode;
  tone?: IconWellTone | undefined;
  /** Already localized. */
  title: string;
  /** Already localized. */
  body: string;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
}

/**
 * Always has a next step. An empty state without an action is a dead end, and a dead end on a
 * payment page is a support ticket.
 */
export function EmptyState({
  icon,
  tone = 'neutral',
  title,
  body,
  action,
  children,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center gap-2.5 py-4 text-center', className)}>
      {icon !== undefined && <IconWell tone={tone}>{icon}</IconWell>}
      <h1 className="text-text text-lg font-semibold tracking-tight" tabIndex={-1}>
        {title}
      </h1>
      <p className="text-text-muted max-w-prose text-sm leading-relaxed">{body}</p>
      {children}
      {action !== undefined && <div className="pt-1">{action}</div>}
    </div>
  );
}
